import { Notifier as AirbrakeInstance } from 'airbrake';

import appPackage from '../../../../package.json';

export type TErrorSideParams = 'server' | 'client';

type INoticeError = Error & {
  isOperational?: boolean;
};

interface INotifyAirbrakeParams {
  error: INoticeError;
  errorSide: TErrorSideParams;
  params?: unknown;
}

interface INoticeParams {
  context: {
    environment: string;
    version: string;
    isOperational: boolean;
  };
}

let instance: AirbrakeInstance | null = null;

export async function notifyAirbrake({
  error,
  errorSide,
  params = {},
}: INotifyAirbrakeParams) {
  const airbrake = await getAirbrakeInstance(errorSide);

  if (!airbrake) {
    return;
  }

  const filters = [
    monitorErrorsOnlyOnProduction,
    addProjectVersion,
    removeOperationalErrors,
  ];

  filters.forEach((filter) => airbrake.addFilter(filter));

  airbrake.notify({
    error,
    params,
    context: {
      isOperational: error.isOperational || false,
    },
  });
}

async function getAirbrakeInstance(
  errorSide: TErrorSideParams
): Promise<AirbrakeInstance | null> {
  if (instance == null) {
    const projectId = Number(process.env.NEXT_PUBLIC_AIRBRAKE_PROJECT_ID);
    const projectKey = process.env.NEXT_PUBLIC_AIRBRAKE_KEY;
    const environment =
      process.env.NEXT_PUBLIC_AIRBRAKE_ENVIRONMENT || 'development';

    if (!projectId || !projectKey) {
      return null;
    }

    instance = new AirbrakeInstance({
      projectId,
      projectKey,
      environment: `${environment} - ${errorSide}`,
    });
  }

  return instance;
}

function monitorErrorsOnlyOnProduction(notice: INoticeParams) {
  if (notice.context.environment.includes('production')) {
    return notice;
  }

  return null;
}

function addProjectVersion(notice: INoticeParams) {
  if (notice.context) {
    notice.context.version = appPackage.version;
  }

  return notice;
}

function removeOperationalErrors(notice: INoticeParams) {
  if (notice.context.isOperational) {
    return null;
  }

  return notice;
}
